import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ind-app-policy-container ml-40 mr-40 mt-10 mb-10" }
const _hoisted_2 = { class: "flex justify-end w-full mgb-16" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-xl" }, null, -1)
const _hoisted_4 = { class: "table-role-list w-full" }
const _hoisted_5 = { class: "text-center py-2" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleRedirectCreate,
        class: "btn-outline-blue h-12 mb-6"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.t('personalSettingApply.buttonAdd')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        data: _ctx.personalSettingApplyList,
        headers: _ctx.headerDatas,
        "show-pagination": "",
        "record-total": _ctx.pagination.total,
        "items-per-pages": _ctx.pagination.per_page,
        currentPage: _ctx.currentPage,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentPage = $event)),
        onOnChangePage: _ctx.onChangePage
      }, {
        pp_employee_name: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_5, [
            _createVNode("a", {
              onClick: ($event: any) => (_ctx.redirectUpdatePersonalApplyUpdate(item)),
              class: "cursor-pointer text-light-blue underline hover:opacity-75"
            }, _toDisplayString(item.pp_employee_name), 9, ["onClick"])
          ])
        ]),
        apply_end_date: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.displayDate(item.apply_end_date)), 1)
        ]),
        apply_start_date: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.displayDate(item.apply_start_date)), 1)
        ]),
        administrative_working_schedule_name: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_8, _toDisplayString(item.administrative_working_schedule_name), 1)
        ]),
        role_name: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_9, _toDisplayString(item.role_name), 1)
        ]),
        is_use_time_zone_session_type: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Checkbox, {
              disabled: "",
              style: { color: '#333333' },
              "model-value": item.is_use_time_zone_session_type
            }, null, 8, ["model-value"])
          ])
        ]),
        _: 1
      }, 8, ["data", "headers", "record-total", "items-per-pages", "currentPage", "onOnChangePage"])
    ])
  ]))
}